import React, { PureComponent } from 'react';
import { withSnackbar } from 'notistack';
import { compose } from 'redux';
import { DialogContent, DialogActions } from '@mui/material';
import { createBlackListedDomains } from '../../api/apis';
import { publishDelayedEvent } from '../../utils/eventUtils';

import CBButton from '../Buttons/CbButton';

import { TextField } from '../inputs';
import { withToggleModal } from '../hocs/withToggleModal';

const initialFormState = {
  name: '',
};

class BlackListCreateModal extends PureComponent {
  state = {
    form: initialFormState,
    disabled: false,
  };

  constructor(props: any) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    const { disabled } = this.state;

    return (
      <DialogContent>
        <TextField
          label="Name"
          placeholder="example.com"
          value={this.state.form.name}
          required
          onChange={this.handleChange('name')}
        />
        <DialogActions>
          <CBButton
            styleName="cancel"
            // @ts-expect-error TS(2339): Property 'toggleModal' does not exist on type 'Rea... Remove this comment to see the full error message
            action={this.props.toggleModal.deferred('BlackListCreate', false)}
            buttonText="Cancel"
            size="large"
          />
          <CBButton
            loading={disabled}
            disabled={disabled}
            action={this.handleSubmit}
            type="submit"
            styleName="ctaButton"
            buttonText="Blacklist Domain"
            size="large"
          />
        </DialogActions>
      </DialogContent>
    );
  }

  handleChange(field: any) {
    const { state } = this;

    return (event: any) => {
      this.setState({
        form: {
          ...state.form,
          [field]: event.target.value,
        },
      });
    };
  }

  handleSubmit() {
    const { state } = this;
    this.setState({
      disabled: true,
    });

    createBlackListedDomains({}, state.form)
      .then(() => {
        // reset the form
        this.setState({ form: initialFormState, disabled: false });

        // fetch new results
        publishDelayedEvent('table:force-fetch-domains');

        // tell user operation was successful
        // @ts-expect-error TS(2339): Property 'enqueueSnackbar' does not exist on type ... Remove this comment to see the full error message
        this.props.enqueueSnackbar('Domain successfully blacklisted', {
          variant: 'success',
        });

        // close the modal
        // @ts-expect-error TS(2339): Property 'toggleModal' does not exist on type 'Rea... Remove this comment to see the full error message
        this.props.toggleModal.direct('BlackListCreate', false);
      })
      .catch(() => {
        // @ts-expect-error TS(2339): Property 'toggleModal' does not exist on type 'Rea... Remove this comment to see the full error message
        this.props.toggleModal.direct('BlackListCreate', false);
        // @ts-expect-error TS(2339): Property 'enqueueSnackbar' does not exist on type ... Remove this comment to see the full error message
        this.props.enqueueSnackbar(
          'Failed to blacklist domain. Please try again.',
          { variant: 'error' }
        );
        this.setState({
          disabled: false,
        });
      });
  }
}

// @ts-expect-error TS(2339): Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
BlackListCreateModal.defaultProps = {
  data: {},
};

export default compose(withSnackbar, withToggleModal)(BlackListCreateModal);
